import { inherits as _inherits, createSuper as _createSuper, createClass as _createClass, classCallCheck as _classCallCheck, defineProperty as _defineProperty } from "../_virtual/_rollupPluginBabelHelpers.js";
import { TrackType } from "./types.js";
var Sample = /* @__PURE__ */ _createClass(
  function Sample2(data, pts) {
    _classCallCheck(this, Sample2);
    _defineProperty(this, "time", 0);
    this.data = data;
    this.originPts = this.pts = pts;
  }
);
var FlvScriptSample = /* @__PURE__ */ function(_Sample) {
  _inherits(FlvScriptSample2, _Sample);
  var _super = _createSuper(FlvScriptSample2);
  function FlvScriptSample2() {
    _classCallCheck(this, FlvScriptSample2);
    return _super.apply(this, arguments);
  }
  return _createClass(FlvScriptSample2);
}(Sample);
var SeiSample = /* @__PURE__ */ function(_Sample2) {
  _inherits(SeiSample2, _Sample2);
  var _super2 = _createSuper(SeiSample2);
  function SeiSample2() {
    _classCallCheck(this, SeiSample2);
    return _super2.apply(this, arguments);
  }
  return _createClass(SeiSample2);
}(Sample);
var MetadataTrack = /* @__PURE__ */ function() {
  function MetadataTrack2() {
    _classCallCheck(this, MetadataTrack2);
    _defineProperty(this, "id", 3);
    _defineProperty(this, "type", TrackType.METADATA);
    _defineProperty(this, "timescale", 0);
    _defineProperty(this, "flvScriptSamples", []);
    _defineProperty(this, "seiSamples", []);
  }
  _createClass(MetadataTrack2, [{
    key: "exist",
    value: function exist() {
      return !!((this.flvScriptSamples.length || this.seiSamples.length) && this.timescale);
    }
  }, {
    key: "reset",
    value: function reset() {
      this.timescale = 0;
      this.flvScriptSamples = [];
      this.seiSamples = [];
    }
  }, {
    key: "hasSample",
    value: function hasSample() {
      return !!(this.flvScriptSamples.length || this.seiSamples.length);
    }
  }]);
  return MetadataTrack2;
}();
export { FlvScriptSample, MetadataTrack, SeiSample };
